import {Axios} from "axios";
import {z} from "zod";
import {EventQuestion} from "../../../models/Models";
import {Option} from "../../../../../components/dropdown/DropdownHelper";

export const getEventQuestionsRequestSchema = z.object({
  data: z.object({
    eventId: z.number(),
  }),
});
export type GetEventQuestionsRequestPayload = z.infer<
  typeof getEventQuestionsRequestSchema
>;

export type EventQuestionsApiResponse = {
  data: {
    questions: EventQuestion[];
  };
  message: string;
};

export type EventQuestionsDataResponse = {
  questions: SanitizedEventQuestion[];
};

export async function getEventQuestions(
  requestPayload: GetEventQuestionsRequestPayload,
  axiosInstance: Axios
): Promise<EventQuestionsDataResponse> {
  getEventQuestionsRequestSchema.parse(requestPayload);
  const response = await axiosInstance.get(
    `event/${requestPayload.data.eventId}/eventQuestion`
  );
  const sanitizedEventQuestions = sanitizeEventQuestions(
    response.data.data.eventQuestions
  );

  return {questions: sanitizedEventQuestions};
}

export type SanitizedEventQuestion = {
  id: number;
  eventId: number;
  question: string;
  type: "text" | "number" | "select" | "email";
  options?: Option[];
  isRequired: boolean;
  orderIndex: number;
};

export function sanitizeEventQuestions(
  questions: EventQuestion[]
): SanitizedEventQuestion[] {
  return questions.map((q) => {
    const sanitizedQuestion: SanitizedEventQuestion = {
      id: q.id,
      eventId: q.eventId,
      question: q.question,
      type: q.type,
      isRequired: q.isRequired,
      orderIndex: q.orderIndex,
    };

    if (q.options) {
      sanitizedQuestion.options = q.options.map((op, index) => ({
        value: `${q.id}-${index}`,
        label: op,
      }));
    }

    return sanitizedQuestion;
  });
}
